import { render, staticRenderFns } from "./integralDetail.vue?vue&type=template&id=4dcefb98&scoped=true"
import script from "./integralDetail.vue?vue&type=script&lang=js"
export * from "./integralDetail.vue?vue&type=script&lang=js"
import style0 from "./integralDetail.vue?vue&type=style&index=0&id=4dcefb98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcefb98",
  null
  
)

export default component.exports